export const MAYBE_FETCH_SESSION_INFO = '@@od/store/session/maybeFetchSessionInfo';
export const FETCH_SESSION_INFO = '@@od/store/session/fetchSessionInfo';
export const BEGIN_LOADING_SESSION_INFO = '@@od/store/session/beginLoadingSessionInfo';
export const RECEIVE_SESSION_INFO = '@@od/store/session/receiveSessionInfo';
export const ERROR_SESSION_INFO = '@@od/store/session/errorSessionInfo';

export const BEGIN_LOG_IN = '@@od/store/session/beginLogIn';
export const ERROR_LOG_IN = '@@od/store/session/errorLogIn';
export const LOG_IN = '@@od/store/session/logIn';
export const SUCCESS_LOG_IN = '@@od/store/session/successLogIn';

export const BEGIN_REQUEST_HUMAN_STATUS = '@@od/store/session/beginRequestHumanStatus';
export const ERROR_REQUEST_HUMAN_STATUS = '@@od/store/session/errorRequestHumanStatus';
export const REQUEST_HUMAN_STATUS = '@@od/store/session/requestHumanStatus';
export const SUCCESS_REQUEST_HUMAN_STATUS = '@@od/store/session/successRequestHumanStatus';

export const BEGIN_REQUEST_RESET_PASSWORD = '@@od/store/session/beginRequestPasswordReset';
export const ERROR_REQUEST_RESET_PASSWORD = '@@od/store/session/errorRequestPasswordReset';
export const REQUEST_RESET_PASSWORD = '@@od/store/session/requestPasswordReset';
export const SUCCESS_REQUEST_RESET_PASSWORD = '@@od/store/session/successRequestPasswordReset';

export const BEGIN_REGISTER = '@@od/store/session/beginRegister';
export const ERROR_REGISTER = '@@od/store/session/errorRegister';
export const REGISTER = '@@od/store/session/register';
export const SUCCESS_REGISTER = '@@od/store/session/successRegister';

export const MAYBE_LOG_OUT = '@@od/store/session/maybeLogOut';
export const LOGGED_OUT = '@@od/store/session/loggedOut';

export const TRACK_EVENT = '@@od/store/session/trackEvent';
